import { render, staticRenderFns } from "./CreatePropertyMaster.vue?vue&type=template&id=1a09151f"
import script from "./CreatePropertyMaster.vue?vue&type=script&lang=js"
export * from "./CreatePropertyMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports